<template>
  <div class="header">
    <div class="header-wrap">
      <div class="header-container">
        <div class="logo l_flex_row" @click="indexfunc">
          <img src="../assets/images/logo1.png" alt="logo" class="logo-img" />
          <div class="logo-wrap">
            <div class="logo-title">{{ ogran_name }}</div>
            <div class="logo-sub">{{ ogran_subname }}</div>
          </div>
        </div>
        <div v-if="isShow" class="right-box">
          <div class="search">
            <el-input
              @keyup.enter.native="search"
              v-model="searchText"
              class="search-input"
              placeholder="请输入活动名称、机构名称"
            ></el-input>
            <el-button
              class="btn_style"
              @click="search"
              icon="el-icon-search"
              type="primary"
              >搜索</el-button
            >
          </div>
          <a class="create-act" href="https://www.yulin365.net/manage/">
            <el-button
              class="cret_activity btn_style"
              round
              icon="el-icon-s-promotion"
              type="primary"
              >我要办活动</el-button
            >
          </a>
          <div class="line"></div>
          <div class="message">
            <router-link style="color: #3370ff" to="/mine/message">
              <i class="el-icon-bell"></i>
            </router-link>
            <div v-if="isHasNews" class="new"></div>
          </div>
          <div class="login">
            <!-- 未登录时 -->
            <div v-if="!isLogin" class="login-no">
              <router-link class="text" to="/login">登录</router-link>
              <i class="line"></i>
              <router-link class="text" to="/register">注册</router-link>
            </div>
            <!-- 登陆成功时 -->
            <div v-else class="login-success">
              <el-dropdown @command="handcommand">
                <span class="el-dropdown-link">
                  <img
                    :src="userinfo.head_portrait"
                    alt="avatar"
                    class="avatar"
                    :onerror="defaultImg"
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">个人中心</el-dropdown-item>
                  <el-dropdown-item command="1">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav" v-if="isShow">
      <div class="nav-wrap">
        <el-menu
          :default-active="activeIndex"
          mode="horizontal"
          class="el-menu-demo"
          @select="menuSelect"
          background-color="#3370ff"
          text-color="#fff"
        >
          <el-menu-item index="1">首页</el-menu-item>
          <el-menu-item
            :index="item.title"
            v-for="(item, index) in menuList"
            :key="index"
            >{{ item.title }}</el-menu-item
          >
          <el-menu-item index="3">活动中心</el-menu-item>
          <el-menu-item index="2">个人中心</el-menu-item>
          <el-menu-item index="10">学者专家</el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  components: {},
  props: ["activeIndex", "hasMessage", "isShow"],
  data() {
    return {
      // activeIndex: "1",
      searchText: "",
      menuList: [],
      isLogin: false,
      isHasNews: false,
      ogran_name: "",
      ogran_subname: "",
      searchInput: "",
      // is_login: false,
      has_message: "",
      // searchInput: "",
      user: {},
      activeName: "first",
      menuList: []
    };
  },
  watch: {},
  computed: {
    defaultImg() {
      return 'this.src="' + require("@/assets/images/headerImg.jpg") + '"';
    },
    ...mapState("user", ["userinfo"])
  },
  methods: {
    ...mapMutations("user", ["setUserInfo"]),
    //   下拉菜单
    handcommand(e) {
      console.log("command", e);
      if (e == 0) {
        // 个人中心
        // this.$router.push("/my");
        this.$router.push("/mine");
      } else {
        //   退出登陆
        // console.log('退出登陆', localStorage.length );
        this.$api.logout().then(res => {
          // localStorage.clear();
          for (let i = 0; i < localStorage.length; i++) {
            let key = localStorage.key(i);
            let rules = ["ogran_id", "ogran_way"];
            if (!rules.includes(key)) {
              localStorage.removeItem(key);
            }
          }
          sessionStorage.clear();
          this.$router.push("/login");
        });
      }
    },
    indexfunc() {
      this.$router.replace("/");
    },
    activityList() {
      var keyword = this.searchText;
      if (keyword == "") {
        sessionStorage.setItem("activity_type", 1);
        this.$router.replace("/activity/undefined");
      } else {
        sessionStorage.setItem("activity_type", 1);
        this.$router.replace("/activity/" + keyword);
      }
      this.$emit("func", this.searchText);
    },
    getUserbylocal() {
      let user = JSON.parse(localStorage.getItem("user"));
      let token = localStorage.getItem("token");
      // console.log(user)
      if (token) {
        this.$data.is_login = true;
      }
      if (user) {
        this.$data.user = user;
      }
    },

    setInputValue() {
      this.searchText = "";
    },
    getInputValue() {
      let keyWord = this.$route.params.keyword;
      //    console.log(keyWord,"头部")
      if (keyWord == "undefined") {
        this.searchText = "";
      } else {
        this.searchText = keyWord;
      }
    },

    menuSelect(key) {
      console.log("menu--", key);
      let currentSelect = this.menuList.findIndex(item => {
        return item.title == key;
      });
      console.log("----------------", currentSelect);
      if (key == 1) {
        this.$router.replace("/");
      } else if (key == 2) {
        this.$router.replace("/mine");
      } else if (key == "视频讲堂") {
        this.menuList[currentSelect].is_legal
          ? this.$router.replace("/videonote")
          : this.$router.push({ path: "/401", query: { key: key } });
        // this.$router.replace("/videonote");
      } else if (key == "有知") {
        this.menuList[currentSelect].is_legal
          ? this.$router.replace("/knowing")
          : this.$router.push({ path: "/401", query: { key: key } });
        // this.$router.replace("/knowing");
      } else if (key == "青青写") {
        // this.$router.replace("/greenwrite");
        this.menuList[currentSelect].is_legal
          ? this.$router.replace("/greenwrite")
          : this.$router.push({ path: "/401", query: { key: key } });
      } else if (key == "深度阅读") {
        // this.$router.replace("/deepread");
        this.menuList[currentSelect].is_legal
          ? this.$router.replace("/deepread")
          : this.$router.push({ path: "/401", query: { key: key } });
      } else if (key == "青青听") {
        // this.$router.replace("/greenlisten");
        this.menuList[currentSelect].is_legal
          ? this.$router.replace("/greenlisten")
          : this.$router.push({ path: "/401", query: { key: key } });
      } else if (key == 3) {
        sessionStorage.setItem("activity_type", 0);
        this.$router.replace("/activity/undefined");
      } else if (key == 10) {
        this.$router.replace("/expert");
      }
    },

    search() {
      let keywowrd = this.searchText;
      if (this.searchText == "") {
        this.$router.push("/activity/undefined");
        console.log("header ---push");
      } else {
        this.$router.push("/activity/" + this.searchText);
      }
      this.$emit("func", this.searchText);
    },
    // 获取菜单
    async getMenu(ogran_id) {
      try {
        // let ogran_id = this.getOgranId();
        let res = await this.$api.getExpendMenu({
          data: {
            ogran_id: ogran_id
          },
          params: {
            group: "pc"
          }
        });
        console.log("---", res);
        let list = res.data.filter(item => {
          if (item.title == "开心") {
            return false;
          }
          return true;
        });
        this.menuList = list;
        console.log("menulist", this.menuList);
        let currRouteName = this.$route.name;
        let rules = {
          deepread: "深度阅读",
          knowing: "有知",
          videoNote: "视频讲堂",
          greenlisten: "青青听",
          greenwrite: "青青写",
          greenwritedetail: "青青写"
        };
        console.log("test", rules[currRouteName]);
        // 判断当前路由是否是有权限访问
        if (list.length == 0) {
          // 哪些页面需要重定向为首页
          let routes = [
            "greenwritedetail",
            "deepread",
            "knowing",
            "videoNote",
            "greenlisten",
            "greenwrite",
            "pastbook",
            "knowingdetail",
            "noteDetail"
          ];
          if (routes.includes(currRouteName)) {
            this.$router.replace("/");
          }
        } else {
          for (let el of list) {
            console.log("cccccccc", el.title == rules[currRouteName]);
            if (el.title == rules[currRouteName]) {
              if (!el.is_legal) {
                this.$router.push({
                  path: "/401",
                  query: {
                    key: rules[currRouteName]
                  }
                });
                break;
              }
            }
          }
        }

        console.log("获取菜单", this.$route.name);
        let data = JSON.stringify(list);
        sessionStorage.setItem("menu", data);
      } catch (error) {
        console.log(error);
      }
    },

    getUserInfo() {
      let user = JSON.parse(localStorage.getItem("user"));
      let userinfo = JSON.parse(localStorage.getItem("userinfo"));
      let token = localStorage.getItem("token");
      this.isLogin = token ? true : false;
      // this.userInfo = user ? user : "";
      if (user) {
        this.setUserInfo(user);
      } else if (userinfo) {
        this.setUserInfo(userinfo);
      }
    },
    //
    getOgranId() {
      let ogran_id = "";
      if (this.$route.name == "Index") {
        ogran_id = this.$route.params.id;
        if (ogran_id) {
          localStorage.setItem("ogran_id", ogran_id);
        } else {
          ogran_id = localStorage.getItem("ogran_id")
            ? localStorage.getItem("ogran_id")
            : "";
        }
      } else {
        ogran_id = localStorage.getItem("ogran_id");
      }
      return ogran_id;
    },

    async getHome(ogran_id) {
      try {
        // let ogran_id = this.getOgranId();
        console.log("机构id", ogran_id);
        // let agencyid = await this.getAgencyId();

        let res = await this.$api.getHome({
          params: {
            ogran_id: ogran_id,
            group: "pc"
          },
          data: {}
        });
        console.log("-----------------", res);
        this.ogran_name = res.data.ogran_name;
      } catch (error) {
        console.error(error);
      }
    },
    // 获取机构id 和 机构名
    async getAgencyId(id) {
      try {
        let res = await this.$api.getAgencyId({
          params: {
            group: "pc",
            ogran_id: id ? id : ""
          },
          data: {}
        });
        console.log("获取机构id", res);
        // 缓存机构id和机构名
        localStorage.setItem("ogran_id", res.data.ogran_id);
        localStorage.setItem("ogran_name", res.data.ogran_name);
        localStorage.setItem("ogran_subname", res.data.ogran_subname);
        // localStorage.setItem('ogran_way', id ? 'url': 'ip');

        this.ogran_name = res.data.ogran_name;
        this.ogran_subname = res.data.ogran_subname;
        return res.data;
      } catch (error) {}
    },
    // 处理是否获取到id
    async handleAgencyId() {
      try {
        console.log("获取机构name", this.$route);
        // debugger
        if (this.$route.params.id && this.$route.name == "Index") {
          this.agencyId = this.$route.params.id;
          return this.$route.params.id;
        } else if (this.$route.query.ogran) {
          let res = await this.getAgencyId(this.$route.query.ogran);
          return res.ogran_id;
        } else {
          // 判断缓存中是否有
          let id = localStorage.getItem("ogran_id");
          console.log("缓存", id);
          if (id) {
            return id;
          } else {
            console.log("====");
            // 缓存中没有就根据ip获取
            let res = await this.getAgencyId();
            return res.ogran_id;
          }
        }
      } catch (error) {}
    },
    // 处理获取机构名
    async handlegetAgencyName() {}
  },
  created() {
    if (this.$route.name == "Index") {
      // 是首页的情况下
      let ogran_id = localStorage.getItem("ogran_id");
      if (ogran_id == 320) {
        localStorage.setItem("ogran_way", "url");
        localStorage.setItem("ogran_id", ogran_id);
      }
      if (
        localStorage.getItem("ogran_way") == "url" ||
        !localStorage.getItem("ogran_way")
      ) {
        // 判断是url访问
        if (this.$route.params.id) {
          this.ogran_id = this.$route.params.id;
          localStorage.setItem("ogran_id", this.$route.params.id);
        } else {
          this.ogran_id = localStorage.getItem("ogran_id");
        }
        localStorage.setItem("ogran_way", "url");
      } else {
        // ip 访问
        if (this.$route.params.id) {
          this.ogran_id = this.$route.params.id;
          localStorage.setItem("ogran_id", this.$route.params.id);
          localStorage.setItem("ogran_way", "url");
        } else {
          this.ogran_id = "";
          localStorage.setItem("ogran_way", "ip");
        }
      }
      this.getAgencyId(this.ogran_id).then(res => {
        this.ogran_id = res.ogran_id;
        this.getMenu(this.ogran_id);
        this.getUserInfo();
      });
    } else {
      // 不是首页的情况下
      this.handleAgencyId().then(res => {
        this.ogran_id = res;
        let ogran_name = localStorage.getItem("ogran_name");
        let ogran_subname = localStorage.getItem("ogran_subname");
        if (ogran_name) {
          this.ogran_name = ogran_name;
          this.ogran_subname = ogran_subname;
        } else {
          this.getAgencyId(res);
        }
        this.getMenu(res);
        this.getUserInfo();
      });
    }
  },
  mounted() {
    console.log("*******************************");
    // console.log('===',this.$route);
    if (this.$route.name == "SearchActivity") {
      let keyword =
        this.$route.params.keyword != "undefined"
          ? this.$route.params.keyword
          : "";
      this.searchText = keyword;
      // this.searchText = this.$route.params.keyword&& ? this.$route.params.keyword : '';
    } else {
    }
  }
};
</script>
<style lang="less" scoped>
.header {
  //   height: 300px;
  &-wrap {
    padding: 30px 0;
  }
  &-container {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    .logo {
      width: 400px;
      height: 70px;
      cursor: pointer;
      &-img {
        width: 70px;
        height: 70px;
        object-fit: contain;
      }
      &-wrap {
        flex: 1;
        margin-left: 10px;
        .logo-title {
          height: 30px;
          font-size: 24px;
          font-weight: 800;
          // color: #3370ff;
          color: #000000;
          letter-spacing: 0.1em;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .logo-sub {
          margin-top: 2px;
          font-size: 14px;
          font-weight: 800;
          letter-spacing: 0.3em;
          // color: #3370ff;
          color: #000000;
        }
      }
    }
    .right-box {
      display: flex;
      flex: 1;
      align-items: center;
      flex-wrap: nowrap;
      .btn_style {
        background-color: #3370ff;
      }
    }
    .search {
      border-radius: 30px;
      overflow: hidden;
      margin-left: auto;
      display: flex;
      align-items: center;
      margin-right: 30px;
      height: 40px;
      border: 1px solid #3370ff;
      &-input {
        width: 277px;
      }
      &-input /deep/ .el-input__inner {
        border-radius: 0px;
        border: none;
      }
      & /deep/ .el-button {
        border-radius: 0;
      }
    }
    .cret_activity {
      font-size: 13px;
    }
    .create-act {
      font-size: 13px;
      display: flex;
      align-items: center;
    }
    .message {
      font-size: 22px;
      color: #3370ff;
      margin-right: 20px;
      cursor: pointer;
      position: relative;
      .new {
        position: absolute;
        width: 6px;
        height: 6px;
        background-color: #ff0000;
        border-radius: 50%;
        top: -5px;
        right: -2px;
      }
    }
    .line {
      width: 1px;
      height: 20px;
      background-color: #999;
      margin: 0 20px;
    }
    .login {
      &-no {
        display: flex;
        align-items: center;
        width: 70px;
        font-size: 14px;
        justify-content: space-between;
        .line {
          width: 1px;
          height: 20px;
          background-color: #3370ff;
          margin: 0;
        }
        .text {
          color: #999;
        }
      }
      &-success {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #3370ff;
        cursor: pointer;
        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
        }
      }
    }
  }
  .nav {
    height: 60px;
    background-color: #3370ff;
    &-wrap {
      width: 1200px;
      margin: 0 auto;
      height: 60px;
      .el-menu-demo {
        height: 60px;
        border-bottom: none;
        & /deep/ .el-menu-item {
          height: 60px;
          width: 120px;
          font-size: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        & /deep/ .is-active {
          background-color: rgba(0, 0, 0, 0.2) !important;
          color: #fff;
        }
        &::after {
          background-color: #f40;
        }
        &::before {
          background-color: #f30;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homeHeader.vue